export default {
  Uuid: '',
  AvatarImagePath: '',
  CreciNumber: '',
  CreciUF: '',
  FullName: '',

};
